import { useSelector } from 'react-redux';
import { ChatListMenu } from './ChatListMenu';
import { ChatRoomPage } from '../../pages/ChatRoomPage';
import { DesktopChatRoomHeader } from './DesktopChatRoomHeader';
import { RootState } from '../../reducers/index';
import { ChatListChatRequestRoom } from './ChatListChatRequestRoom';
import { isChatApproved } from '../../utilities/Chat';

export function DesktopChat() {
	const chatInFocus = useSelector((state: RootState) => state.chatInFocus);
	const loggedInUserDetails = useSelector((state: RootState) => state.loggedInUserDetails);
	const isLoading = useSelector((state: RootState) => state.showLoader);

	return (
		<div className={isLoading ? 'hidden' : 'chat-layout h-[calc(100dvh-60px)] w-full min-w-0 overflow-hidden'}>
			<aside className="h-full min-w-0 overflow-hidden bg-white md:border-r md:border-solid md:border-slate-200">
				<ChatListMenu />
			</aside>
			<section className="chat-room-pane min-h-0 min-w-0 flex-col overflow-hidden bg-slate-50">
				{chatInFocus && loggedInUserDetails ? (
					<div className="flex min-h-0 flex-1 flex-col">
						<DesktopChatRoomHeader />
						{isChatApproved(chatInFocus, loggedInUserDetails.id) ? <ChatRoomPage /> : <ChatListChatRequestRoom />}
					</div>
				) : (
					<div className="flex min-h-0 flex-1 items-center justify-center p-8">
						<img alt="Select a chat to begin messaging" className="h-60 w-60 max-w-full object-contain" src="/chat-room-empty-state.png" />
					</div>
				)}
			</section>
		</div>
	);
}
